<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-progress *ngIf="loading"></app-progress>
  <app-sending *ngIf="sending"></app-sending>
  <div class="setting-form" *ngIf="!loading">
    <table>
      <tbody>
        <tr>
          <th>区分</th>
          <td>
            <select [(ngModel)]="setting.notificationDivision">
              <option value="1">お知らせ</option>
              <option value="2">障害</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>ボタンタイトル</th>
          <td><input type="text" [(ngModel)]="setting.buttonTitle" /></td>
        </tr>
        <tr>
          <th>ボタンテキスト</th>
          <td><input type="text" [(ngModel)]="setting.buttonText" /></td>
        </tr>
        <tr>
          <th>トップでポップアップ表示するか</th>
          <td>
            <select [(ngModel)]="setting.showPopupOnTopPage">
              <option [ngValue]="true">する</option>
              <option [ngValue]="false">しない</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>ポップアップタイトル</th>
          <td><input type="text" [(ngModel)]="setting.popup.title" /></td>
        </tr>
        <tr>
          <th>ポップアップテキスト見出し</th>
          <td><input type="text" [(ngModel)]="setting.popup.content" /></td>
        </tr>
        <tr>
          <th>ポップアップテキスト詳細</th>
          <td>
            <textarea
              rows="5"
              [(ngModel)]="popupListItemsText"
              placeholder="1行に1件入力"
            ></textarea>
          </td>
        </tr>
        <tr>
          <th>ポップアップリンクテキスト</th>
          <td><input type="text" [(ngModel)]="setting.popup.linkText" /></td>
        </tr>
        <tr>
          <th>ポップアップ閉じるボタンテキスト</th>
          <td><input type="text" [(ngModel)]="setting.popup.closeButtonText" /></td>
        </tr>
        <tr>
          <th>リンクURL</th>
          <td><input type="text" [(ngModel)]="setting.linkUrl" /></td>
        </tr>
        <tr>
          <th>アクショントランザクションキー</th>
          <td><input type="text" [(ngModel)]="setting.actionTransactionKey" /></td>
        </tr>
        <tr>
          <th>有効期限終了日</th>
          <td><input type="datetime-local" [(ngModel)]="endDatetimeLocal" /></td>
        </tr>
      </tbody>
    </table>

    <div class="actions">
      <button type="button" class="c-btn" (click)="loadSetting()">再読込</button>
      <button type="button" class="c-btn c-btn--blue" (click)="save()">保存</button>
    </div>
  </div>
</app-main-contents>
